export default {
  document: 'Dokument',
  note: 'Note',
  esdh_system: 'ESDH-system',
  file_and_document: 'Filer & dokumenter',
  secure_file: 'Sikre filer',
  journalise_to_esdh_system: 'Journaliser i ESDH-system',
  journalise_to_system: 'Journaliser i {system}',
  no_esdh_system_specified: 'Din kommune har endnu ikke opsat et modtagende ESDH-system.',
  esdh_limit_warning_1: 'Der er allerede et aktivt ESDH system.',
  esdh_limit_warning_2: 'Slet det eksisterende inden der kan oprettes et nyt.',
  exceeded_regarding_children_warning_1:
    'Følgende filer kan ikke blive sendt til journalisering i {systemName}, fordi de omhandler flere end 28 børn.',
  exceeded_regarding_children_warning_2:
    'Nævnte filer bliver fjernet fra listen og bliver ikke sendt til journalisering i {systemName}.',
  sending_documents_to_esdh_system_information: 'Du er ved at sende følgende filer til {systemName}.',
  total_selected_files: 'Antal filer markeret til journalisering i {systemName}: {total}',
  esdh_export_information: 'Filer bliver kun journaliseret for de børn, der er markeret med flueben.',
  journalization_in_progress: 'Journalisering i gang',
  journalization_completed: 'Filen er journaliseret i {systemName}',
  journalized: 'Journaliseret',
  journalization_failed: 'Journalisering fejlede',
  no_regarding_children_warning_1:
    'Følgende filer kan ikke sendes til journalisering i {systemName}, fordi der ikke er mindst et barn tilknyttet.',
  no_regarding_children_warning_2:
    'De filer bliver derfor fjernet fra listen af filer, der bliver journaliseret i {systemName}.',
  sending_document_warning:
    'Du er ved at sende <strong>{number}</strong> fil til {systemName}. | Du er ved at sende <strong>{number}</strong> filer til {systemName}.',
  document_locked_warning:
    'Filerne vil derefter blive {lockedText}, hvilket betyder, at du IKKE vil kunne redigere filerne efter afsendelse.',
  unlock_being_exported_document_warning:
    'Denne fil er i gang med at blive journaliseret, derfor kan den ikke låses op på nuværende tidspunkt.',
  export_invalid_journalized_status_warning:
    'Det er ikke muligt at journalisere filer, der er i gang med at blive journaliseret, allerede er journaliseret eller har fejlet journalisering.',
  remove_listed_documents_warning: 'Nævnte filer bliver derfor fjernet fra listen.',
  file_is_being_journalized: 'Filen er under journalisering, og kan ikke slettes',
  can_not_unlock_file_being_exported: 'Filen er under journalisering, og kan ikke låses op',
  can_not_journalize_completed_document: 'Filen er journaliseret, og kan ikke journaliseres igen',
  can_not_journalize_in_progress_document: 'Filen er under journalisering, og kan ikke journaliseres igen',
  can_not_journalize_failed_document: 'Filen fejlede under journalisering, og afventer administrator',
  no_export_permission_warning_1:
    'Du har valgt en eller flere filer, du ikke har rettighed til at journalisere {extendedMessage}',
  no_export_permission_warning_2: 'som vil blive fjernet fra eksportlisten',
  no_recipients_configured_warning: 'Din kommune har ikke opsat et modtagende ESDH-system.',
  no_files: 'Der er ingen filer.',
  remove_association: 'Fjern tilknytning',
  remove_association_without_edit_right_warning:
    'Din tilknytning til følgende filer bliver {notText} fjernet, da du ikke har redigeringsrettighed til dem:',
  continue_without_listed_files_confirmation: 'Vil du fortsætte uden nævnte filer?',
  remove_association_warning_1: 'Hvis du fortsætter, bliver din tilknytning til de valgte sikre filer fjernet.',
  remove_association_warning_2: 'Det betyder, at du mister adgang og redigeringsret til dem.',
  number_of_selected: 'Antal valgte filer: {number}',
  functionalities: 'Fil funktionaliteter',
  mark_as_read: 'Markér som læst',
  mark_as_unread: 'Markér som ulæst',
  select_all: 'Vælg alle dokumenter',
  exceeded_pdf_export_warning:
    'Du kan kun eksportere op til {total} filer. Hvis du vil fortsætte, skal du afmarkere mindst {remove} filer.',
  import_new_file: 'Importer ny fælles fil',
  edit_file: 'Rediger fil',
  file_association: 'Hvem skal filen vises for?',
  file_association_help_text:
    'Vælg hele institutionen, specifikke profiltyper i institutionen eller søg efter en gruppe.',
  file_association_note:
    'Bemærk, hvis du angiver både profiltype og gruppe, vil alle brugere, der opfylder mindst ET af disse kriterier, kunne se filen. Det betyder, at hvis filen er delt med alle medarbejdere og en gruppe, vil alle ansatte på institutionen OG alle medlemmer af gruppen kunne se filen - også selvom de er børn eller forældre.',
  one_child_selected_warning: 'Mindst ét barn skal være tilknyttet filen.',
  deleted_files_description: 'Her kan du se og gendanne alle slettede noter og sikre filer fra din institution.',
  input_case_number: 'Angiv sagsnummer',
  add_case_number: 'Tilføj sagsnummer',
  close_case_number: 'Luk felt til angivelse af sagsnummer',
  missing_case_number: 'Angiv sagsnummer eller luk feltet for at fortsætte ',
  revision_created: 'Fil oprettet',
  revision_edited: 'Fil redigeret',
  revision_deleted: 'Fil slettet',
  revision_exported: 'Eksporteret som pdf',
  revision_restored: 'Fil gendannet',
  revision_shared: 'Delt med: {userName}',
  revision_unshared: 'Fjernet deling med: {userName}',
  revision_implicit_unshared: 'Fjernet automatisk deling med: {userName}',
  revision_unlocked: 'Fil låst op',
  revision_locked: 'Fil låst',
  revision_permission_added: 'Redigeringsret tildelt: {userName}',
  revision_permission_removed: 'Redigeringsret fjernet: {userName}',
  revision_sent_to_esdh: 'Filen blev sendt til journalisering i {recipientName} ({childrenNames})',
  revision_journalized_to_esdh: 'Filen blev journaliseret i {recipientName} ({childrenNames})',
  revision_esdh_journalization_failed: 'Filen kunne ikke journaliseres i {recipientName} ({childrenNames})',
  revision_resent_to_esdh: 'Filen blev gensendt til journalisering i {recipientName} ({childrenNames})',
  revision_marked_journalize_manually:
    'Filen blev markeret til at skulle journaliseres manuelt i {recipientName} ({childrenNames})',
  revision_manually_journalized_to_esdh: 'Filen blev journaliseret manuelt i {recipientName} ({childrenNames})',
  history_version_not_available: 'Ikke tilgængelig',
  filter_by_category_and_template: 'Søg efter kategorier og skabeloner',
  filter_by_category: 'Søg efter kategorier',
  filter_by_recipient: 'Søg efter modtagere',
  change_template_affect_existed_document_warning:
    'Ændringer i titel og kategori vil slå igennem på alle eksisterende og nye sikre filer, som bruger denne dokumentskabelon.',
  template_changes_apply_when_publish_document:
    'For dokumentskabeloner som ikke er publiceret, vil ændringerne først træde i kraft, når dokumentskabelonen er publiceret.',
  changes_to_title_and_category_template: 'Ændringer i titel og kategori',
  changes_to_title_and_category_template_effects:
    'Slår igennem på alle eksisterende og nye sikre filer, som bruger dokumentskabelonen. Ændringerne træder først i kraft, når dokumentskabelonen er publiceret.',
  changes_to_title_and_category_template_advice:
    'Ønsker du ikke at ændre i eksisterende sikre filer som bruger dokumentskabelonen, bør du oprette en ny skabelon i stedet for.',
  changes_to_text_field_template: 'Ændringer i tekstfeltet',
  changes_to_text_field_template_effects:
    'Påvirker kun nye sikre filer, som benytter dokumentskabelonen. Eksisterende sikre filer vil derfor ikke blive påvirket af ændringer i tekstfeltet.',
  no_template: 'Ingen skabelon',
  select_secure_file: 'Vælg sikker fil',
  export_document: 'Eksport forberedes',
  export_documents_that_may_contain_sensitive_data:
    'Vær opmærksom på, at du er ved at eksportere en eller flere sikre filer, der kan indeholde følsomme personoplysninger.',
  remember_to_delete_or_store_documents_in_secure_places:
    'Husk at slette de downloadede filer eller sikre dig, at de ligger et sikkert sted, efter de er hentet.',
  export_in_progress_percent: 'Eksport i gang, {percent}%',
  export_ready_to_download: 'Eksport færdig, klar til download',
  title_too_long_warning: 'Title må ikke være mere end 255 tegn lang',
  title_require_warning: 'Du skal angive en titel',
};
